import ArrowOutwardIcon from '@mui/icons-material/ArrowOutwardRounded';
import LockIcon from '@mui/icons-material/LockOutlined';
import ClosedSourceProjects from '../utility/ClosedSourceProjects';
import { useTilt } from '../utility/motion';

function ClosedProjectCard({project, checked, index}) {
    const ref = useTilt(7);
    const language = checked ? 'it' : 'en';

    return (
        <article
            ref={ref}
            className="work-card card tilt"
            data-reveal
            style={{ '--d': `${index * 120}ms`, '--accent': project.accent }}
            aria-labelledby={`work-${project.id}`}
        >
            <span className="card__spotlight" aria-hidden="true" />
            <span className="work-card__glow" aria-hidden="true" />

            <header className="work-card__head">
                <span
                    className={`work-card__icon ${project.iconFit === 'contain' ? 'is-contain' : ''}`}
                    style={project.iconBackground ? { background: project.iconBackground } : undefined}
                >
                    <img src={project.icon} alt="" loading="lazy" />
                </span>
                <span className="badge">
                    <LockIcon className="badge__icon" />
                    Closed source
                </span>
            </header>

            <span className="work-card__index mono" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
            <p className="work-card__category mono">{project.category[language]}</p>
            <h3 className="work-card__title" id={`work-${project.id}`}>{project.name}</h3>
            <p className="work-card__desc">{project.description[language]}</p>

            <ul className="work-card__tech" aria-label={checked ? 'Tecnologie' : 'Technologies'}>
                {project.technology.map((tech) => (
                    <li key={tech.label} style={{ '--c': tech.color }}>{tech.label}</li>
                ))}
            </ul>

            <footer className="work-card__foot">
                {project.link ? (
                    <a
                        href={project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="work-card__link"
                    >
                        {checked ? 'Visita il sito' : 'Visit website'}
                        <ArrowOutwardIcon className="work-card__link-icon" />
                    </a>
                ) : (
                    <span className="work-card__private mono">
                        {checked ? 'Codice privato' : 'Private codebase'}
                    </span>
                )}
            </footer>
        </article>
    );
}

function ClosedSource({checked}) {
    return (
        <section className="section work" id="work" aria-labelledby="work-title">
            <div className="section__head" data-reveal>
                <span className="eyebrow"><span className="eyebrow__index">04</span>Closed source</span>
                <h2 className="section__title" id="work-title">
                    {checked ? 'Progetti closed source' : 'Closed-source projects'}
                </h2>
                <p className="section__lead">
                    {checked
                        ? 'Software realizzato per clienti e attività: il codice resta privato, ma il risultato parla da sé.'
                        : 'Software built for clients and businesses: the code stays private, but the result speaks for itself.'}
                </p>
            </div>

            <div className="work__grid">
                {ClosedSourceProjects.map((project, index) => (
                    <ClosedProjectCard key={project.id} project={project} checked={checked} index={index} />
                ))}
            </div>
        </section>
    );
}

export default ClosedSource;
